import http from '../api/http'

export default {
  add: (inventoryCount) => http.post('/inventory-counts/add', inventoryCount, { timeout: 300000 }),
  addItem: (uuid, productId) => http.post('/inventory-counts/add-item', { uuid, productId }),
  cancelInventoryCount: (uuid) => http.post('/inventory-counts/cancel-inventory-count', { uuid }),
  completeInventoryCount: (uuid) => http.post('/inventory-counts/complete-inventory-count', { uuid }),
  getInventoryCount: (uuid) => http.get('/inventory-counts/get-inventory-count', { params: { uuid } }),
  importInventoryList: (uuid, conditions, importEnabledOnly) => http.post('/inventory-counts/import-inventory-list', { uuid, conditions, importEnabledOnly }, { timeout: 60000 }),
  importUrlList: (uuid, url) => http.post('/inventory-counts/import-url-list', { uuid, url }, { timeout: 120000 }),
  pagination: (conditions, pagination) => http.get('/inventory-counts/pagination', { params: { conditions, pagination } }),
  removeItem: (itemUuid) => http.delete('/inventory-counts/remove-item', { data: { itemUuid } }),
  removeAllItems: (uuid) => http.delete('/inventory-counts/remove-all-items', { data: { uuid } }),
  resetInventoryCount: (uuid) => http.post('/inventory-counts/reset-inventory-count', { uuid }),
  resetItemCount: (uuid, productId) => http.post('/inventory-counts/set-item-count', { uuid, productId, counted: null }),
  setItemCount: (uuid, productId, counted) => http.post('/inventory-counts/set-item-count', { uuid, productId, counted }),
  setUncountedItemsToZero: (uuid, itemUuids = []) => http.post('/inventory-counts/set-uncounted-items-to-zero', { uuid, itemUuids })
}



// WEBPACK FOOTER //
// ./src/services/inventory-counts.js